import React from 'react'
import { useChatWindow } from '@ztechapps/chat.chat-window'
import styles from './index.module.css'

export default function CallToActionSection() {
  const { toggleShow } = useChatWindow()

  return (
    <section id="cta" className={styles.cta}>
      <div className="container">
        <div className="row">
          <div className="col-lg-5 text-center text-lg-start">
            <h3>Ready to dive in?</h3>
            <p>Start using the Total Milk within a day after confirmation.</p>
          </div>
          <div className="col-lg-7 cta-btn-container text-center">
            <a
              className={`${styles.ctaBtn} align-middle`}
              href="/"
              onClick={(e) => {
                e.preventDefault()
                return toggleShow()
              }}
              id={'message-us'}
            >
              Message Us Now!
            </a>

            <a className={`${styles.ctaBtn} align-middle`} href="tel:8556455776">
              Call toll-free 855.645.5776
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
